import { createAsyncThunk } from "@reduxjs/toolkit";
import { Axios } from "api/axios";
import { InventoryAxios } from "api/InventoryAxios";
import { WarehouseAxios } from "api/WarehouseAxios";
import axios from "axios";

// export interface District {
//   id?: string;
//   packageName: string; 
//   districtCode: string;
//   districtName: string;
//   state: string;
//   status: boolean; 
//   createBy?: string; 
//   updatedBy?: string; 
//   createDate?: string;  
//   updateDate?: string;
// }
export interface PaginatedResponse<T> {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export const fetchInventoryPacking = createAsyncThunk(
  "inventory/fetchPacking",
  async ({
    page,
    pageSize,
    sort,
    order,
    search,
    filters,
    type
  }: {
    page: number;
    pageSize: number;
    search?: string;
    sort?: string;
    order?: "asc" | "desc" | "";
    filters?: any;
    type?: string;
  }) => {
    const params = new URLSearchParams();
    params.append("page", page.toString());
    params.append("page_size", pageSize.toString());
    if (search) params.append("search", search);
    if (sort) {
      const orderingValue = order === "desc" ? `-${sort}` : sort;
      params.append("ordering", orderingValue);
    }  
  

    if (filters && filters.length > 0) {
      console.log(JSON.stringify(filters));
      filters.forEach(
        ({
          filterField,
          filterValue,
        }: {
          filterField: string;
          filterValue: any;
        }) => {
          if (
            filterField &&
            filterValue !== undefined &&
            filterValue !== null
          ) {
            if (typeof filterValue === "object" && filterValue !== null) {
              Object.entries(filterValue).forEach(([key, value]) => {
                if (value !== undefined && value !== null && value !== "") {
                  params.append(key, String(value));
                }
              });
            } else {
              params.append(filterField, filterValue);
            }
          }
        }
      );
    }


    if (type === 'Transfer') {
       const response: any = await WarehouseAxios.get(
        `packing/packing_done_list/?${params.toString()}`
      );  
 
 
      return {
        data: response?.data?.results || [],
        rowCount: response.data.count || 0,
      };
    } else if (type === 'Allocation') {

       const response: any = await WarehouseAxios.get(
        `/packing/allocation/allocation-packing-done-list/?allocation_packing_type=Allocation&${params.toString()}`
      );
      console.log("response Allocation : ", response);
      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } else if (type === 'Items Request') {
     const response: any = await WarehouseAxios.get(
        `/packing/allocation/allocation-packing-done-list/?allocation_packing_type=Item Request&${params.toString()}`
      );
      console.log("response Item Request : ", response);
      return {
        data: response?.data?.data || [],
        rowCount: response?.data?.count || 0,
      };
    } else {
      return {
        data: [],
        rowCount: 0,
      };
    }
  }
);


export const fetchPackingViewDetailsByID = createAsyncThunk(
  "fetch/fetchPackingViewDetailsByID",
  async (packing_done_id: string, { rejectWithValue }) => {
    try {
      const response = await WarehouseAxios.get(
        `/packing/packing-done/transfer-id-view-details/${packing_done_id}/`
      );

      console.log('response data', response?.data)
      return response?.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || "Failed to fetch packing view details"
      );
    }
  }
);